import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';

export const styles = StyleSheet.create({
    bold: {
        fontFamily: Fonts.main.bold,
    },
    center: {
        textAlign: 'center',
    },
    androidAlignement: {
        includeFontPadding: false,
        textAlignVertical: 'center',
    },
});

export const textSizeStyles = StyleSheet.create({
    bold: {
        fontWeight: 'bold',
    },
    title1: {
        fontSize: 32,
        fontFamily: Fonts.main.bold,
    },
    title2: {
        fontSize: 24,
        fontFamily: Fonts.main.bold,
    },
    title3: {
        fontSize: 20,
        fontFamily: Fonts.main.bold,
    },
    body1: {
        fontSize: 16,
        fontFamily: Fonts.main.regular,
    },
    body2: {
        fontSize: 14,
        fontFamily: Fonts.main.regular,
    },
    caption1: {
        fontSize: 12,
        fontFamily: Fonts.main.regular,
    },
    caption2: {
        fontSize: 10,
        fontFamily: Fonts.main.regular,
    },
});

export const textColorStyles = StyleSheet.create({
    light_grey: {
        color: lightGrey(0.7),
    },
    high_contrast: {
        color: '#FFFFFF',
    },
    low_contrast: {
        color: '#252525',
    },
    primary: {
        color: COLOR.primary,
    },
    secondary: {
        color: '#F9A21C',
    },
    error: {
        color: '#bc0000',
    },
    success: {
        color: '#4A8C73',
    },
    neutral: {
        color: '#eeeeee',
    },
    black: {
        color: COLOR.BLACK,
    },
    dark_grey: {
        color: lightGrey(0.5),
    },
    transparent: {
        color: 'transparent',
    },
});
